import { Component, ElementRef, Input, ViewChild, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, UntypedFormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { AppService } from "src/app/app.service";
import { DhlFormControlEventData } from "../../dhl-form/models/dhl-form-control-event-data";
import { Router } from '@angular/router';
import { DhlFormControlEvent } from "../../dhl-form/models/dhl-form-control-event";
import { TranslateService } from '@ngx-translate/core';
import { Constant } from '../../constants/constants';
import { Modal } from "src/app/common/modal/modal";
import { ModalService } from "src/app/common/modal/modal.service";
import { FormService } from "../../dhl-form/services/form.service";
import isEqual from 'lodash/fp/isEqual';

@Component({
    selector: "app-generic-form-filter-v3",
    templateUrl: "./generic-form-filter-v3.component.html",
    styleUrls: ["./generic-form-filter-v3.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericFormFilterV3Component implements AfterViewInit {
  showFilters: boolean = false;
  filterApplied: boolean = false;
  filterTerms = new Subject<any>();
  tempValCount = 0;
  valCount = 0;

  @Input() configData;
  @Input() frmGroup;

  @ViewChild('filter', { static: true, read: ElementRef }) filter: ElementRef;
  commonData = Constant;
  commonModalSubject: any;
  queryType: string;
  saveFilterPayload: any;
  applyFilterPayload: any;
  commonSubject;
  disableSave: boolean = false;
  selectedSavedSearch;
  filterName;

  constructor(private formService: FormService, private modalService: ModalService, private appService: AppService, private router: Router, public translate: TranslateService, private cdr: ChangeDetectorRef) { }
  form: any;

  ngOnInit() {
    this.disableSave = true;
    // NCP-12544 start-Specific requirement for default value set - COX
    if(!localStorage.getItem('firstVerificationListing')) {
      if(this.configData && this.configData.groups) {
        this.configData.groups.forEach((data) => {
          if(data.name === 'orderDetails' && data.controls) {
            data.controls.forEach((ctrl) => {
              if(ctrl.name === 'status') {
                ctrl.defaultValue = {
                  "displayValue": "",
                  "value": "",
                  "selectedOption": "",
                  "filterValue": "",
                  "filterValueV3": "",
                  "onlySelection": false,
                  "dataType": "OBJECT"
                };
              }
            })
          }
        })
      }
    } // // NCP-12544 end
  }

  ngAfterViewInit() {
    if (this.configData.hasOwnProperty("storeDataName")) {
      if (sessionStorage.getItem(this.configData.storeDataName + "-Payload") && sessionStorage.getItem(this.configData.storeDataName + "-Payload") !== "undefined") {
        this.applyFilterPayload = JSON.parse(sessionStorage.getItem(this.configData.storeDataName + "-Payload"));
      }

      if (sessionStorage.getItem(this.configData.storeDataName)) {
        let localFilterForm = JSON.parse(sessionStorage.getItem(this.configData.storeDataName));
        if (localFilterForm) {

          this.form.patchValue(localFilterForm);

          if (localFilterForm["savedSearch"] && localFilterForm["savedSearch"]["value"]) {
            this.appService._components["savedSearch"].showDeleteFilterButton = true;
          }

          // if (localFilterForm["savedSearch"] && localFilterForm["savedSearch"]["displayValue"]) {
          //   let displayValue = localFilterForm["savedSearch"]["displayValue"];
          //   let option = this.appService._components["savedSearch"].configData.options;
          //   let selectedOption = option.filter(ele => ele.displayValue === displayValue.toString());
          //   localFilterForm["savedSearch"] = selectedOption[0];
          //   this.filterName = displayValue;
          //   this.appService._components["savedSearch"].setValueToControl(selectedOption[0]);
          // }

          for (let field in localFilterForm) {
            let value = localFilterForm[field];
            if (value && this.appService._components[field] && this.appService._components[field].configData) {

              if (this.appService._components[field].configData.component === 'TOGGLEGROUP_V2') {
                this.appService._components[field].setValueToControl(value);
              }
              else if (this.appService._components[field].configData.component === "DROPDOWN_MULTISELECT_V2") {
                this.appService._components[field].setValueToControl(value);
              }
              // else if (this.appService._components[field].configData.component === 'DROPDOWN_SIMPLE_V2') {
              //   this.appService._components[field].setValueToControl(value);
              // }
              // else if (this.appService._components[field].configData.component === "GENERIC_FIELD_V2") {
              //   this.appService._components[field].setValueToControl(value.toString());
              // }
              // else {
              //   this.appService._components[field].setValueToControl(value.toString());
              // }
            }
          }
          this.sendFilterToSource(null, null);
        }
      }
    }
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'INIT');
    if (event) {
      this.sendFilterToSource([event], null);
    }

    this.commonModalSubject = this.appService._modalCommonFormSubjecct.subscribe(data => {
      if (data.formValue && data.event === 'save') {
        Object.keys(data.formValue).forEach((key => {
          if (data.formValue[key]) {
            let val = data.formValue[key].trim();
            this.saveFilterPayload = Object.assign({ "queryName": val }, this.saveFilterPayload);
          }
        }))
        this.queryType = data.formValue.existingFilterName ? 'UPDATE_FILTER' : 'INSERT_FILTER';
        this.sendFilterToSource(null, true);
      }
    });

    this.commonSubject = this.appService._commonComponentSubjectFilter.subscribe(data => {
      if (data) {

        if (data.action == "SET_SAVED_SEARCH") {

          this.clearFilters(false);
          this.form.get(data.name).setValue(data.data);
          let obj = data.data.queryText ? JSON.parse(data.data.queryText) : "";
          let query = obj ? obj.query : "";
          let predefinedQuery = obj ? obj.preDefinedQueries : "";
          this.selectedSavedSearch = obj;
          this.disableSave = true;

          if (predefinedQuery) {
            if (this.appService._components["predefined_query"] && this.appService._components["predefined_query"].configData) {
              let option = this.appService._components["predefined_query"].configData.options;
              let selectedOption = option.filter(ele => ele.displayValue === predefinedQuery.toString());
              this.appService._components["predefined_query"].setValueToControl(selectedOption[0]);
            }
          }

          Object.keys(query).forEach(key => {

            if (this.form.get(key)) {
              let val = query[key][0]['value'];

              if (this.appService._components[key] && this.appService._components[key].configData) {

                if (this.appService._components[key].configData.component === 'DROPDOWN_SIMPLE_V2') {
                  let option = this.appService._components[key].configData.options;
                  let x = this.appService._components[key].configData.operator === "nestedOR" ? query[key][0]['secondaryVal'].toString() : val.toString()
                  let selectedOption = option.filter(ele => ele.value === x);
                  this.appService._components[key].setValueBySelection(selectedOption[0]);
                }
                else if (this.appService._components[key].configData.component === 'TOGGLEGROUP_V2') {
                  let option = this.appService._components[key].configData.options;
                  let x = this.appService._components[key].configData.operator === "nestedOR" ? query[key][0]['secondaryVal'].toString() : val.toString()
                  let selectedOption = option.filter(ele => ele.value === x);
                  this.appService._components[key].setValueToControl(selectedOption[0]);
                }
                else if (this.appService._components[key].configData.component === "DROPDOWN_MULTISELECT_V2") {
                  let option = this.appService._components[key].configData.options;
                  let displayValue = query[key][0]["displayValue"];
                  let selectedOption = option.filter(ele => displayValue.includes(ele.displayValue));
                  this.appService._components[key].setValueToControl(selectedOption);
                }
                else if (this.appService._components[key].configData.component === "GENERIC_FIELD_V2") {
                  let x = this.appService._components[key].configData.operator === "nestedOR" ? query[key][0]['secondaryVal'].toString() : val.toString()
                  this.appService._components[key].setValueToControl(x);
                }
                else {
                  let x = this.appService._components[key].configData.operator === "nestedOR" ? query[key][0]['secondaryVal'].toString() : val.toString()
                  this.appService._components[key].setValueToControl(x);
                }
              }
            }
          })
        }
        // this.cdr.detectChanges();
        if (data.action === 'ENABLE_SAVE') {
          if (this.selectedSavedSearch) {
            let payloadData = this.getSaveFilterPayload();
            let savePayload = payloadData.data.queryText;
            let savedSearch = this.selectedSavedSearch;
            let compareValue = isEqual(savePayload, savedSearch);
            if (!compareValue) {
              this.disableSave = false;
            }
            else {
              this.disableSave = true;
            }
          }
          else {
            this.disableSave = false;
          }
        }
      }
    });

    // console.log(this.form,this.form.value)
    this.checkIfIsDisable();
  }

  checkIfIsDisable() {
    let payloadData = this.getSaveFilterPayload();
    let savePayload = payloadData.data.queryText;
    let savedSearch = this.form.get("savedSearch").value && this.form.get("savedSearch").value['queryText'] ? JSON.parse(this.form.get("savedSearch").value['queryText']) : { "orderBy": this.configData['orderBy'] || '', "query": {} };
    this.selectedSavedSearch = savedSearch;
    let compareValue = isEqual(savePayload, savedSearch);
    if (!compareValue) {
      this.disableSave = false;
    }
    else {
      this.disableSave = true;
    }
  }

  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  openFilterOptions($event) {
    $event.stopImmediatePropagation();
    // this.showFilters = $event && $event.pointerType ? !this.showFilters : this.showFilters;
    this.showFilters = $event && $event.type === "mouseup" ? !this.showFilters : this.showFilters;
    if (this.showFilters) {
      this.filter.nativeElement.classList.add('active');
    }
    // if (!this.filterApplied && this.form) {
    //   if (this.configData.customFilter !== true) { // to discuss with Alpha team
    //     this.form.reset();
    //   }
    // }
  }

  // setFormFields() {
  //   if (this.form) {
  //     if (this.configData.customFilter === true) {
  //         this.customFilterSetForm();
  //     }
  //   }
  // }

  getForm(event) {
    this.form = event;
    // this.setFormFields(); // to discuss with Alpha team
  }

  sendFilterToSource(events, userEvent) {
    if (events) {
      events = events;
    } else {
      events = this.configData.events;
    }
    let sourceData;
    sourceData = this.form.value;

    Object.keys(this.form.controls).forEach((key) => {
      sourceData[key] = this.form.get(key).value;
    })

    let eventData: DhlFormControlEventData = {
      event: events[0].event,
      eventData: events[0],
      action: events[0].action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: { "saveData": this.saveFilterPayload, "applyData": this.applyFilterPayload }
    };
    if (this.configData.hasOwnProperty("storeDataName")) {
      sessionStorage.setItem(this.configData.storeDataName, sourceData ? JSON.stringify(sourceData) : sourceData);
      sessionStorage.setItem(this.configData.storeDataName + '-Payload', this.applyFilterPayload ? JSON.stringify(this.applyFilterPayload) : this.applyFilterPayload);
    }
    eventData['userEvent'] = userEvent;
    eventData['queryType'] = this.queryType;
    this.appService._commonComponentSubject.next(eventData);
    this.queryType = '';
    this.showFilters = false;
    this.filterApplied = true;
    this.setFormFilterCount();
    this.setFilterName(this.saveFilterPayload ? this.saveFilterPayload['queryName'] : '');
  }

  setFilterName(val = "") {
    if (val) {
      this.filterName = val;
    }
    else if (this.form && this.form.get('savedSearch') && this.form.get('savedSearch').value && this.form.get('savedSearch').value['queryName']) {
      this.filterName = this.form.get('savedSearch').value.displayValue;
    }
    else {
      this.filterName = '';
    }
  }

  setFormFilterCount() {
    this.tempValCount = 0;
    for (let cltr in this.form.controls) {
      if (this.form.controls[cltr].value && cltr !== "savedSearch") {
        if (typeof this.form.controls[cltr].value === 'object') {
          if (this.form.controls[cltr].value instanceof Array && this.form.controls[cltr].value.length > 0) {
            this.tempValCount++;
          }
          else {
            if (this.form.controls[cltr].value.value) {
              this.tempValCount++;
            }
          }
        }
        else {
          this.tempValCount++;
        }
      }
    };
  }

  customFilterSetForm() {
    let currentURL = this.router.url;
    if (localStorage.getItem('filterCurrenturl') == currentURL) {
      for (let obj in this.form.value) {
        if (localStorage.getItem(currentURL + obj))
          this.form.get(obj).setValue(localStorage.getItem(currentURL + obj))
      }
    }

  }

  saveAndApplySearchFilters(data, event, btnType) {
    let payloadData = this.getSaveFilterPayload();
    let saveDetail = JSON.parse(JSON.stringify(payloadData.data));
    let applyDetail = JSON.parse(JSON.stringify(payloadData.data.queryText.query));
    if (payloadData.data.queryText['orderBy']) {
      applyDetail['orderBy'] = JSON.parse(JSON.stringify(payloadData.data.queryText['orderBy']));
    }

    if (payloadData.queryValue) {
      let val = JSON.parse(payloadData.queryValue);
      if (val.query) {
        Object.keys(val.query).forEach((querydata) => {
          let isMatch = Object.keys(applyDetail).includes(querydata)
          if (isMatch) {
            for (let i = 0; i < val.query[querydata].length; i++) {
              applyDetail[querydata].push(val.query[querydata][i]);
            }
          } else {
            applyDetail[querydata] = val.query[querydata];
          }
        });
      }
    }

    this.saveFilterPayload = saveDetail;
    this.applyFilterPayload = applyDetail;

    // if(this.applyFilterPayload["status"] && this.applyFilterPayload["status"][0]){
    //   delete this.applyFilterPayload["status"][0]['displayValue'];
    // }    
    Object.keys(this.applyFilterPayload).forEach((key) => {
      delete this.applyFilterPayload[key][0]['displayValue'];
      delete this.applyFilterPayload[key][0]['secondaryVal'];
    })


    if (btnType === 'save') {
      if (data.modalControls) {
        let isDisabled = false;
        let options;
        data.modalControls.controls.forEach((ctrl) => {
          if (ctrl.name === 'existingFilterName') {
            options = ctrl.options;
            isDisabled = ctrl.options.length > 24 ? true : isDisabled;
          }
          if (ctrl.name === 'newFilterName') {
            ctrl.disabled = isDisabled;
          }
        })
        let form: UntypedFormGroup;
        form = this.formService.simpleFormCreation({
          controls: data.modalControls.controls,
        });
        let modal = new Modal({
          action: true, name: 'newFilterModal', title: 'Save This Search', description: '', actionButtonText: '',
          modalForm: { modalName: 'newFilterSearchModal', type: 'newFilterModal', template: data.modalControls, frmGroup: form, editMode: false, fieldOptions: options },
          style: { width: "450px", height: "500x" }
        });
        this.modalService.createModalBox(modal, 200);
      }
    }
    else if (btnType === 'apply') {
      this.saveFilterPayload = '';
      this.sendFilterToSource(null, event);
    }
  }

  getSaveFilterPayload() {
    let saveFilterData = {};
    let queryName;
    let queryValue;
    let orderBy = this.configData['orderBy'] || '';
    this.configData.groups.forEach((group) => {
      group.controls.forEach((control) => {
        let formValue = this.form.get(control.name).value;
        if (formValue && (typeof formValue === 'object') && !(formValue instanceof Array)) {
          formValue = formValue.value;
        }

        if (formValue && control.name !== "savedSearch") {
          if (control.name === "predefined_query") {
            queryName = this.form.get(control.name).value.displayValue;
            queryValue = this.form.get(control.name).value.value;
            let val = JSON.parse(queryValue);
            if (val && val.orderBy) {
              orderBy = val.orderBy;
            }
          }
          else {
            if (control.component === "DROPDOWN_MULTISELECT_V2") {
              let displayVal = this.getFieldValue(this.form.get(control.name).value, "displayValue");
              let val = this.getFieldValue(this.form.get(control.name).value, "filterValueV3");
              let operator = this.getOperatorValue(control);

              if (val && val.length > 0) {
                if (operator === 'nestedOR') {
                  let operatorValue = control.operatorValue ? control.operatorValue : false;
                  let newVal = [];
                  val.forEach((data) => {
                    let obj = {}
                    obj[data] = operatorValue;
                    newVal.push(obj);
                  })
                  saveFilterData[control.name] = [{
                    "displayValue": displayVal,
                    "value": newVal,
                    "secondaryVal": val,
                    "operator": operator
                  }]
                } else {
                  saveFilterData[control.name] = [{
                    "displayValue": displayVal,
                    "value": val,
                    "operator": operator
                  }]
                }
              }
            }

            else if (control.name === 'estimatedPickupDate' || control.name === 'estimatedDropoffDate') {
              let val = this.getFieldValue(this.form.get(control.name).value);
              let data = val[0].split('-');
              let operator = this.getOperatorValue(control);
              if (val && val.length > 0) {

                if (operator === 'nestedOR') {
                  let operatorValue = control.operatorValue ? control.operatorValue : false;
                  let newVal = [];
                  val.forEach((data) => {
                    let obj = {}
                    obj[data] = operatorValue;
                    newVal.push(obj);
                  })
                  saveFilterData[control.name] = [{
                    "value": newVal,
                    "secondaryVal": val,
                    "operator": operator
                  }]
                } else {
                  saveFilterData[control.name] = [{
                    "value": [data[0]],
                    "operator": operator
                  }]
                }
              }
            }
            // Multi value search by comma separated
            else if (control.component === 'GENERIC_FIELD_V2' && control.separateByCommaAndSpace) {
                let val = this.getFieldValue(this.form.get(control.name).value)
                let operator = this.getOperatorValue(control);
                let obj = JSON.parse(JSON.stringify(val));
                obj = obj.toString().trim();
                let objArrVals = obj.split(/[,]+/).map(item => item.trim());
                let textValue = objArrVals.filter(x => x != '');
                if(textValue && textValue.length > 0) {
                  saveFilterData[control.name] = [{
                    "value": textValue,
                    "operator": operator
                  }]
                }
            }
            else if (control.name === "shipmentType") {
              let val = this.form.get(control.name).value.value;

              val.split(',').forEach(item => {

              let field = item.split('=')[0];
              let expression = item.split('=')[1];
              let op = expression.split('~')[0];
              let rawValue = expression.split('~')[1];

              let actualValue: any = rawValue;

              if (rawValue === 'true') {
                actualValue = true;
              } else if (rawValue === 'false') {
                actualValue = false;
              } else if (op === 'between') {
                actualValue = rawValue.split(',');
              }

              saveFilterData[field] = [{
                "value": actualValue instanceof Array ? actualValue : [actualValue],
                "operator": op
              }];
              });
            }
            else {
              let val = this.getFieldValue(this.form.get(control.name).value)
              let operator = this.getOperatorValue(control);
              if (val && val.length > 0) {
                if (operator === 'nestedOR') {
                  let operatorValue = control.operatorValue ? control.operatorValue : false;
                  let newVal = [];
                  val.forEach((data) => {
                    let obj = {}
                    obj[data] = operatorValue;
                    newVal.push(obj);
                  })
                  saveFilterData[control.name] = [{
                    "value": newVal,
                    "secondaryVal": val,
                    "operator": operator
                  }]
                } else {
                  saveFilterData[control.name] = [{
                    "value": val,
                    "operator": operator
                  }]
                }
              }
            }
          }
        }
      })
    })

    let a = { "query": saveFilterData };
    if (orderBy) {
      let obj = { "orderBy": orderBy };
      Object.assign(a, obj);
    }
    if (queryName) {
      let obj = { "preDefinedQueries": [queryName] }
      Object.assign(a, obj)
    }
    let payload = { data: { "queryText": a }, "queryValue": queryValue };
    return payload;
  }

  getFieldValue(val, flag = "") {
    if (typeof val === 'object') {
      let x = val.value;
      if (x === 'true') {
        x = true;
      } else if (x === 'false') {
        x = false;
      }

      if (val instanceof Array) {
        let fieldArray = [];
        val.forEach((y) => {
          let z = flag ? y[flag] : y.value;
          if (z instanceof Array) {
            fieldArray = fieldArray.concat(z)
          }
          else {
            fieldArray.push(z);
          }
        })
        return Array.from(new Set(fieldArray.sort()));
      } else {
        return Array.from(new Set([x]));
      }
    }
    else if (typeof val === 'string') {
      return Array.from(new Set([val]));
    }
  }

  getOperatorValue(control) {
    if (typeof control.operator == 'object') {
      if (control.operator instanceof Array) {
        let val;
        control.operator.forEach((data) => {
          if (Object.keys(data).toString() === this.form.get(control.name).value.displayValue) {
            val = Object.values(data).toString();
          }
        })
        return val;
      }
    } else {
      return control.operator
    }
  }

  clearFilters(userEvent) {
    sessionStorage.removeItem(this.configData.storeDataName);
    sessionStorage.removeItem(this.configData.storeDataName + "-Payload");
    this.selectedSavedSearch = '';
    this.filterName = '';
    this.tempValCount = 0;
    this.form.reset();
    for (let field in this.form.controls) {
      const control = this.form.get(field);
      if (this.appService._components[field].configData.component == 'DATEPICKER_V2') {
        this.appService._components[field].filterDate = this.translate.instant(Constant.Filter_Popup_Status_All);
      }
      
      if (this.appService._components[field].configData.component == 'FILTER_V2') {
        let placeholder = this.appService._components[field].configData.placeHolder || this.appService._components[field].configData.placeholder;
        if (typeof placeholder === 'string') {
          placeholder = this.translate.instant(placeholder);
        }
        this.appService._components[field].selectedOption(placeholder, true);
      }
      if (this.appService._components[field].configData.component == 'TOGGLEGROUP_V2') {
        this.appService._components[field].resetToggleBtnGroupValue();
      }
      if (this.appService._components[field].configData.component == 'DROPDOWN_MULTISELECT_V2') {
        this.appService._components[field].resetAllSelection();

      }
      control['secondaryText'] = "";
    }
    // });

    if (userEvent) {
      this.showFilters = false;
      this.queryType = '';
      this.saveFilterPayload = '';
      this.applyFilterPayload = '';
      this.applyFilterPayload = { "orderBy": this.configData['orderBy'] || '' };
      if (this.appService._components["savedSearch"]) {
        this.appService._components["savedSearch"].showDeleteFilterButton = false;
      }
      setTimeout(() => {
        this.sendFilterToSource(null, userEvent);
      }, 500)
    }
    this.filterApplied = false;
  }

  ngOnDestroy() {
    if (this.commonModalSubject) {
      this.commonModalSubject.unsubscribe();
    }
    if (this.commonSubject) {
      this.commonSubject.unsubscribe();
    }
  }

}
